import { Controller } from 'stimulus'
import debounce from 'lodash/debounce'

export default class extends Controller {
  initialize() {
    this.save = debounce(this.save, 500).bind(this)
    this.trixSave = debounce(this.trixSave, 500).bind(this)
  }

  save(event) {
    const target = event.currentTarget || event.target
    target.form.requestSubmit()
  }

  trixSave(event) {
    const target = event.currentTarget || event.target
    target.closest("form").requestSubmit()
  }

  showLoader() {
    misc.show_preloader()
  }
}
